/**
 * Template: Page - Commitment
 * ------------------------------------------------------------------------------
 */
import {load} from '@shopify/theme-sections';
import '../sections/page-commitment';
import '../../styles/templates/page.commitment.scss';

document.addEventListener('DOMContentLoaded', () => {
  load('page-commitment');
});
